// Still to be finished converting from Handlebars
<template>
   <div>
      <h2>{{data.title}}</h2>
      <div v-html="data.message" />
      <div v-if="data.showDetails" class="info row">
         <div class="col-md-10 col-md-offset-1">
            <p class="error-message">{{data.error}}</p>
               <table v-if="data.details" class="table stack-trace">
                  <tr>
                     <th colspan="3">Stack Trace</th>
                  </tr>
                     <tr v-if="detail in details">
                           <td colspan="3" v-if="detail.text">{{detail.text}}</td>
                           <template v-else>
                           <td >{{detail.function}}</td>
                           <td>{{detail.file}}</td>
                           <td>{{detail.line}}:{{detail.column}}</td>
                           </template>
                     </tr>
               </table>
         </div>
      </div>
   </div>
</template>

<script>
   import extend from 'extend'

   export default {
      props: ['data'],
      data () {
         return {
            error: null
         }
      },
      mounted() {
         this.$store.dispatch('global/updateBreadcrumbs')
         // Copy the data so we can reset the global
         // this.error = extend(true, {}, this.data)
      },
      beforeUnmount() {
         // this.$store.commit('global/setPageData', null)
      }
   }
</script>
